import { ReactNode } from 'react';
import {
  BoxProps,
  Drawer as ChakraDrawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerContentProps,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerProps as ChakraDrawerProps,
  ModalBodyProps,
  ModalFooterProps,
  ModalHeaderProps,
  ModalOverlayProps,
} from '@chakra-ui/react';
import Icon from '../Icon/Icon';

export interface DrawerProps
  extends Pick<ChakraDrawerProps, 'finalFocusRef' | 'initialFocusRef' | 'isOpen' | 'onClose' | 'onCloseComplete'> {
  children: DrawerContentProps['children'];
  footer?: ReactNode;
  maxWidth?: BoxProps['maxWidth'];
  title: ReactNode;
  padding?: BoxProps['padding'];
  margin?: BoxProps['margin'];
  headerPadding?: BoxProps['padding'];
  bodyPadding?: BoxProps['padding'];
  overlayProps?: ModalOverlayProps;
  contentProps?: DrawerContentProps;
  headerProps?: ModalHeaderProps;
  bodyProps?: ModalBodyProps;
  footerProps?: ModalFooterProps;
}

const Drawer = ({ overlayProps, contentProps, headerProps, bodyProps, footerProps, ...props }: DrawerProps) => {
  const {
    bodyPadding,
    children,
    footer,
    headerPadding,
    maxWidth = '20rem',
    padding,
    margin,
    title,
    ...drawerProps
  } = props;

  return (
    <ChakraDrawer {...drawerProps}>
      <DrawerOverlay {...overlayProps} />
      <DrawerContent maxWidth={maxWidth} padding={padding} margin={margin} {...contentProps}>
        <DrawerCloseButton size="md">
          <Icon name="Cross" />
        </DrawerCloseButton>
        <DrawerHeader as="h3" padding={headerPadding} {...headerProps}>
          {title}
        </DrawerHeader>
        <DrawerBody padding={bodyPadding} {...bodyProps}>
          {children}
        </DrawerBody>
        {footer && <DrawerFooter {...footerProps}>{footer}</DrawerFooter>}
      </DrawerContent>
    </ChakraDrawer>
  );
};

export default Drawer;
